export const SetAddressData = async (data: any, dispatch: any, state: any) => {
  let { street, nr, bus, postal, city, country, coordinates } = data;

  //*** set lat and lang */
  let lat = "";
  let lng = "";

  if (coordinates !== "") {
    [lat, lng] = coordinates
      .replace("Lat: ", "")
      .replace("Lng: ", "")
      .split(", ");
  }

  dispatch({
    type: "UPDATE_GENERAL_FIELD",
    field: "initialLat",
    value: lat,
  });

  dispatch({
    type: "UPDATE_GENERAL_FIELD",
    field: "initialLn",
    value: lng,
  });

  //****  */

  // Match the country dropdown. Prefer the ISO code coming from Google so the
  // country still resolves when its display name differs slightly (e.g.
  // "Belgium" vs "België"); fall back to an exact, then partial, name match.
  if (country !== "") {
    const iso = (data.countryIso || "").toLowerCase();
    const name = country.trim().toLowerCase();
    const list = state.dropDowndata.countryList || [];
    country =
      (iso &&
        list.find((option: any) => (option.iso || "").toLowerCase() === iso)) ||
      list.find((option: any) => option.label.trim().toLowerCase() === name) ||
      list.find((option: any) =>
        option.label.toLowerCase().includes(name)
      );
  }

  // If country matches, filter cities by removing prefixes and using case-insensitive comparison
  // if (country && country.value === 29 && city !== "") {
  //   city = state.dropDowndata.citiesList.find((option: any) =>
  //     option.name.toLowerCase().includes(city.toLowerCase())
  //   ) || null;
  // }
  let cityOther = "";

  if (country && [29, 182, 93].includes(country.value) && city !== "") {
    city = {value: city, label: `${postal} - ${city}`};
  } else {
    cityOther = city;
    city = null;
  }

  let resedentialAdd = {
    street: street,
    number: nr,
    city: city,
    country: country,
    zipCode: postal,
    box: bus,
    cityOther: cityOther,
  };

  Object.entries(resedentialAdd).forEach(([key, value]) => {
    dispatch({
      type: "UPDATE_GENERAL_FIELD",
      field: key,
      value: value,
    });
  });

  if (state.general.domCheckbox === 1 || state.general.domCheckbox === true) {
    Object.entries(resedentialAdd).forEach(([key, value]) => {
      const domField = `dom${key.charAt(0).toUpperCase()}${key.slice(1)}`; // Convert key to domKey format
      dispatch({
        type: "UPDATE_GENERAL_FIELD",
        field: domField,
        value: value,
      });
    });
  }
};
